<fcom-generic-icon [iconRef]="iconRef" [url]="svgPath" />
<span *ngIf="informative" class="is-vishidden">{{ 'icons.' + name | finLocalization }}</span>
